export const appendIfFilled = (payload: Record<string, unknown>, key: string, value?: string | null) => {
  const trimmedValue = value?.trim();

  if (trimmedValue) {
    // eslint-disable-next-line no-param-reassign,security/detect-object-injection
    payload[key] = trimmedValue;
  }
};
